import Cookies from 'js-cookie'

// For forcast page provide the cookie
export function getUserSelectInfo (type) {
  return Cookies.get(type)
}

export function setUserSelectInfo (type, selectInfo) {
  return Cookies.set(type, selectInfo, { expires: 30 })
}

export function removeUserSelectInfo (type) {
  return Cookies.remove(type)
}
